import { Injectable } from '@angular/core';
import { RequestBodyService } from './request-body.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FeatureFlagsEnum, ResultTabsetUrlsEnum } from '../enums';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
    providedIn: 'root'
})
export class ResultsService {
    readonly checkIsNavigating$: Observable<symbol>;
    readonly selectedTabIndex$: Observable<number>;
    isGTMCanvasEnabled: boolean = false;

    private readonly selectedTabIndexSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    private readonly checkIsNavigatingSubject: Subject<symbol> = new Subject<symbol>();

    constructor(
        private readonly router: Router,
        private readonly requestBodyService: RequestBodyService,
        private readonly featureFlagService: FeatureFlagService,
    ) {
        this.featureFlagService.getFlag(FeatureFlagsEnum.GTMCanvas)
            .subscribe((flag) => this.isGTMCanvasEnabled = flag);
        this.checkIsNavigating$ = this.checkIsNavigatingSubject.asObservable();
        this.selectedTabIndex$ = this.selectedTabIndexSubject.asObservable();
    }

    setSelectedIndex(index: number): void {
        if (index > -1 && this.selectedTabIndexSubject.getValue() !== index) {
            this.selectedTabIndexSubject.next(index);
        }
    }

    async changeTab(url: ResultTabsetUrlsEnum, showInSearch = false): Promise<void> {
        if (!this.router.url.includes(url) || showInSearch) {
            this.checkIsNavigatingSubject.next(Symbol(''));
            if (url === ResultTabsetUrlsEnum.COMPANIES || url === ResultTabsetUrlsEnum.CONTACTS) {
                this.requestBodyService.isValid.next(false);
            }

            await this.router.navigateByUrl(url);
            this.requestBodyService.selectedTab.next(url);
        }
    }
}
